import { Dispatch, SetStateAction, } from 'react'
import { Group } from '@mantine/core'
import { DifferentTime } from './DifferentTime'
import { Checkbox } from '@forwardflow/ui-v2'
import { SameTime } from './SameTime'
import { IAvailabilityDay } from '@forwardflow/types/onboarding'

export const WeeklyAvailability = ({
   isSameForAllDays,
   setIsSameForAllDays,
   selectedDays,
   setSelectedDays,
}: {
   isSameForAllDays: boolean
   setIsSameForAllDays: Dispatch<SetStateAction<boolean>>
   selectedDays: IAvailabilityDay[]
   setSelectedDays: Dispatch<SetStateAction<IAvailabilityDay[]>>
}) => {


   return (
      <div>
         <Group className="px-8 py-6 pb-4 border-b border-white/10">
            <Checkbox
               size="xs"
               checked={isSameForAllDays}
               onChange={() => setIsSameForAllDays(!isSameForAllDays)}
            />
            <p className="text-white/90 font-medium text-sm">
               Use the same hours across multiple days
            </p>
         </Group>
         {isSameForAllDays ? (
            <SameTime
               selectedDays={selectedDays}
               setSelectedDays={setSelectedDays}
            />
         ) : (
            <DifferentTime
               selectedDays={selectedDays}
               setSelectedDays={setSelectedDays}
            />
         )}
      </div>
   )
}
